import React, {useEffect, useState} from 'react'
import {withTranslation} from 'react-i18next'
import {BsArrowBarRight} from 'react-icons/bs'
import {useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import DataTable from '../../components/DataTable'
import DeleteButton from '../../components/DeleteButton'
import ModalInserts from '../../components/inserts/ModalInserts'
import Pagination from '../../components/Pagination'
import Select from '../../components/Select'
import {selectUser} from '../../features/user/userSlice'
import {action, deleteItem, getItem, getTableWithFilter} from '../../services/service'
import EditButton from '../../components/EditButton'
import SettingButton from '../../components/SettingButton'
import SearchInput from "../../components/search/SearchInput";
import {Context} from "../../context/SearchContext";
import {useContext} from "react";
import {toast} from "react-toastify";
import TempDataTable from "../../components/TemDataTable";
import Loading from "../../components/loading";
import CopyButton from "../../components/CopyButton";


const headerTable = [{
    name: "id", sort: false
}, {
    name: "name", sort: true
}, {
    name: "article", sort: true
}, {
    name: "supplier", sort: true
}, <span className="sr-only">Edit</span>,];

const bodyTable = [
    "id",
    "productName",
    "article",
    "supplierName",
    "actions",
];

function InsertsLayout({t}) {
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [itemOffset, setItemOffset] = useState(0);
    const [forcePage, setForcePage] = useState(0);
    const [open, setOpen] = useState(false);
    const [item, setItem] = useState(null);
    const [data, setData] = useState({
        data: [],
        recordsTotal: 0,
        pageCount: 1,
    });
    const [isLoading, setIsLoading] = useState(true);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortDir, setSortDir] = useState("DESC");
    const [clear, setClear] = useState(false);
    const {token} = useSelector(selectUser);
    const navigate = useNavigate();
    const ctx = useContext(Context);

    const handlePageClick = (event) => {
        setForcePage(event.selected);
        const newOffset =
            (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
        setItemOffset(newOffset);
    };

    const onclickSetting = (item) => {
        if (item?.id > 0) {
            navigate(`/inserts/layout/page/${item.id}`, {state: {item: item}});
        }
    };

    const onclickEdit = (id) => {
        (async () => {
            let url = `${process.env.REACT_APP_HOST_BASE_URL}/v1/consist/${id}`;
            let res = await getItem(url, token);
            if (res.success) {
                setItem(res.data);
                setOpen(true);
            }
        })();
    };
    const onclickDelete = async (id) => {
        const responseReceived = await swal({
            text: "Are you sure,you want to remove this item?",
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            setIsLoading(true);
            let url = `${process.env.REACT_APP_HOST_BASE_URL}/v1/consist/${id}`;
            let res = await deleteItem(url, token);
            if (res.success) {
                fetchDataConsist();
                setIsLoading(false);
                toast.success(t('action.delete_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            } else {
                console.log(res.message);
                setIsLoading(false);
            }
        }
    };
    const fetchDataConsist = async () => {
        const response = await getTableWithFilter(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/consist/table`,
            token,
            {
                id: null,
                draw: 1,
                start: itemOffset,
                length: itemsPerPage,
                recordsTotal: 0,
                columns: [],
                order: [{column: sortColumn, dir: sortDir}],
                search: {value: ctx.state, regex: true},
                filter: {},
            }
        );
        if (response.success) {
            setIsLoading(false);
            setClear(false);
            let reviewData = response.data.data.map((item, index) => {
                return {
                    id: index + 1,
                    productName: item.productName,
                    article: item.article,
                    supplierName: item.supplierName,
                    actions: (
                        <div className="flex justify-end mt-3 sm:mt-0 sm:ml-4">
                            <SettingButton onclick={(e) => onclickSetting(item)}/>
                            <CopyButton onclick={() => onCopyRow(item.id)}/>
                            <EditButton onclick={(e) => onclickEdit(item.id)}/>
                            <DeleteButton onclick={() => onclickDelete(item.id)}/>
                        </div>
                    ),
                };
            });
            setData({
                data: reviewData,
                recordsTotal: response.data.recordsFiltered,
                pageCount: Math.ceil(
                    response.data.recordsFiltered / parseInt(itemsPerPage)
                ),
            });
        } else {
            setIsLoading(false);
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (clear) {
            fetchDataConsist();
        }
    }, [clear]);

    useEffect(() => {
        fetchDataConsist();
    }, [itemOffset, itemsPerPage, ctx.state]);

    const sortFunction = (value) => {
        setSortColumn(value.field ? value.field : "id");
        setSortDir(value.sort === true ? 'ASC' : 'DESC');
        setClear(true);
    }
    const onCopyRow = async (id) => {
        const responseReceived = await swal({
            title: t(`action.copy_item.title`),
            text: t(`action.copy_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            setIsLoading(true);
            let url = `${process.env.REACT_APP_HOST_BASE_URL}/v1/consist/copy/${id}`;
            let res = await action(url, "POST", token);
            if (res.success) {
                fetchDataConsist();
                setIsLoading(false);

            } else {
                navigate("/error", {
                    state: {
                        status: res.status,
                        message: res.message ? res.message : null,
                    },
                });
            }
        }
    };
    return (
        <>
            {isLoading && <Loading/>}
            <ModalInserts open={open} setOpen={setOpen} item={item} fetchData={fetchDataConsist}/>
            <div className="px-4 py-4 sm:px-6 lg:px-8">
                <div className="mb-2 sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-xl font-semibold text-gray-900">
                            {t(`insert`)}
                        </h1>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                        <button
                            className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                            onClick={() => {
                                setOpen(true);
                            }}
                        >
                            {t(`add_inserts`)}
                            <BsArrowBarRight className="w-6 h-6 ml-1 "/>
                        </button>
                    </div>
                </div>

                <div className="flex justify-between items-center">
                    <Select
                        setItemsPerPage={setItemsPerPage}
                        itemsPerPage={itemsPerPage}
                    />
                    <SearchInput/>
                </div>
                <TempDataTable
                    data={data.data}
                    headerTable={headerTable}
                    bodyContent={bodyTable}
                    sortFunction={sortFunction}
                />
                <Pagination
                    handlePageClick={handlePageClick}
                    pageCount={data?.pageCount}
                    forcePage={forcePage}
                />
            </div>
        </>
    )
}

export default withTranslation()(InsertsLayout)
